import React from 'react';
import styled from 'styled-components';
import shortid from 'shortid';

import { colors } from '../../../shared/styles';

const StyledTextInput = styled.div`
    color: ${colors.grey.default};
    padding: 10px 20px;

    & label {
        font-size: 13px;
        display: block;
        padding: 6px 0;
    }

    & .input-wrapper {
        display: flex;
        background: ${colors.white};
        border: solid 1px ${colors.offWhite};
        border-radius: 4px;
    }

    & .prefix {
        box-sizing: border-box;
        font-size: 14px;
        padding: 6px 10px;
        border-right: solid 1px ${colors.offWhite};
        white-space: nowrap;
    }

    & .suffix {
        box-sizing: border-box;
        font-size: 14px;
        padding: 6px 10px;
        border-left: solid 1px ${colors.offWhite};
        white-space: nowrap;
    }

    & input {
        width: 100%;
        box-sizing: border-box;
        padding: 6px 10px;
        font-size: 14px;
        border-radius: 4px;
        border: none;
    }

    & input[disabled] {
        background: ${colors.offWhiteLighter};
    }

    &.input-error {
        & label {
            color: ${colors.error.default};
        }

        & .input-wrapper {
            border-color: ${colors.error.default};
        }

        span {
            display: block;
            color: ${colors.error.default};
            font-size: 13px;
            margin-top: 5px;
        }
    }

    &.validating {
        .validation-spinner {
            display: block;
            border-left: solid 1px ${colors.offWhite};
            padding: 5px 10px;
        }
    }
`;

type TextInputProps = {
    disabled?: boolean,
    input: any,
    label: string,
    maxLength?: number,
    placeholder?: string,
    prefix?: string,
    suffix?: string,
    type?: string,
    meta?: object,
};

const TextInput = (props: TextInputProps) => {
    const {
        disabled,
        input,
        label,
        maxLength,
        placeholder,
        prefix,
        suffix,
        type,
        meta: { asyncValidating, touched, error, submitFailed } = {},
    } = props;

    const id = shortid.generate();
    const inputType = type || 'text';

    let inputWrapperClass = 'input-wrapper';

    if (prefix && suffix) {
        inputWrapperClass = `${inputWrapperClass} ${inputWrapperClass}__prefix-suffix`;
    } else if (prefix) {
        inputWrapperClass = `${inputWrapperClass} ${inputWrapperClass}__prefix`;
    } else if (suffix) {
        inputWrapperClass = `${inputWrapperClass} ${inputWrapperClass}__suffix`;
    }

    const showError = (touched || submitFailed) && error && !asyncValidating;
    const errorClass = showError ? 'input-error' : '';
    const validationClass = asyncValidating ? 'validating' : '';
    const wrapperClass = `${errorClass} ${validationClass}`;

    return (
        <StyledTextInput className={wrapperClass}>
            {label &&
                <label htmlFor={id}>
                    {label}:
                </label>}
            <div className={inputWrapperClass}>
                {prefix &&
                    <div className="prefix">
                        {prefix}
                    </div>}
                <input
                    {...input}
                    disabled={disabled}
                    type={inputType}
                    id={id}
                    maxLength={maxLength}
                    placeholder={placeholder}
                />
                {suffix &&
                    <div className="suffix">
                        {suffix}
                    </div>}
                {asyncValidating &&
                    <span className="validation-spinner">
                        <i className="fa fa-circle-o-notch fa-spin fa-fw" />
                    </span>}
            </div>
            {showError &&
                <span>
                    {error}
                </span>}
        </StyledTextInput>
    );
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/shared/forms/TextInput.js